import React from "react";
import AISearch from "../../AISearch/AISearch";

/** Same Ask TG chat — visual answers only. */
export default function AskTgNewV2() {
  return <AISearch visualAnswers />;
}
